"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var label_1 = require("../label");
var ratioStyleFactory = function (ratio) {
    var paddingTop = 0;
    switch (ratio) {
        case 1.1:
            paddingTop = 100;
            break;
        case 3.2:
            paddingTop = 66.66;
            break;
        case 4.3:
            paddingTop = 75;
            break;
        case 8.5:
            paddingTop = 62.5;
            break;
        case 16.9:
            paddingTop = 56.25;
            break;
    }
    return { paddingTop: paddingTop + "%" };
};
exports.default = (function (_a) {
    var children = _a.children, theme = _a.theme, className = _a.className, title = _a.title, content = _a.content, imageUrl = _a.imageUrl, actionIconName = _a.actionIconName, _b = _a.actionIconSize, actionIconSize = _b === void 0 ? 2.2 : _b, _c = _a.ratio, ratio = _c === void 0 ? 16.9 : _c, others = tslib_1.__rest(_a, ["children", "theme", "className", "title", "content", "imageUrl", "actionIconName", "actionIconSize", "ratio"]);
    return (React.createElement("div", tslib_1.__assign({}, others, { className: classnames_1.default(theme.card, className) }),
        React.createElement("div", { className: theme.poster, style: tslib_1.__assign({}, ratioStyleFactory(ratio), { backgroundImage: "url(" + imageUrl + ")" }) },
            React.createElement("div", { className: theme.inner }, children)),
        content ? content : null,
        (title || actionIconName) ? (React.createElement("div", { className: theme.title },
            title ? React.createElement(label_1.Label, { nunito: true, uppercase: false, size: 14 }, title) : null,
            actionIconName ? React.createElement(icon_1.Icon, { className: theme.icon, iconName: actionIconName, size: actionIconSize }) : null)) : null));
});
